module.exports = __webpack_public_path__ + "img/dcfl02.12f1f2ec.png";